<template>
  <div class="box text-gray">
    參考編號：{{number}}
  </div>
</template>

<script>
export default {
  name: "TestNumber",
  props: {
    number: {type: String}
  }
}
</script>

<style scoped>
  .box{
    position: static;
    display: block;
    width: fit-content;
    max-width: 90%;
    margin: auto auto 0;
    padding-top: 2rem;
    padding-bottom: 1rem;
    min-height: clamp(2rem, 4vw, 2.5rem);
    line-height: 1.2;
    font-size: var(--ecs-font-sm);
    text-align: center;
    color: #666666;
    background: transparent;
    border-radius: 0;
    box-shadow: none;
    pointer-events: none;
  }
</style>
